/** 409 of the backend for an assistant card still held by another request past the wait. */
export const ASSISTANT_CARD_BUSY_CODE = 'assistant_action_busy';

/** 409 of the backend for an assistant card already created (Crea, other tab, a first dialog save). */
export const ASSISTANT_CARD_CONFIRMED_CODE = 'assistant_action_already_confirmed';
